.iconButton {
  color: var(--base-white);
  border-radius: 0.25rem;
  background: var(--base-white);
  /* Shadow/xs */
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);

  display: inline-flex;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:focus,
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 4px 4px rgba(66, 210, 243, 0.4);
  }

  &:global(.round) {
    border-radius: 50%;
  }

  svg {
    height: 1rem;
    fill: var(--base-black);
  }

  &.sm {
    padding: 0.25rem;

    svg {
      height: 0.75rem;
    }
  }

  &.lg {
    svg {
      height: 1.5rem;
    }
  }

  /* Only this variant is used */
  &.tertiary {
    background: var(--button-color-tertiary);
    border: none;
    box-shadow: none;

    &:active {
      border: 2px solid var(--button-icon-tertiary-color-border-active);
      background: var(--button-icon-tertiary-color-bg-active);
    }

    &:focus,
    &:focus-visible {
      border: 2px solid var(--button-color-focus-border);
      padding: calc(0.5rem - 2px);
    }
    &:hover {
      background: var(--button-icon-tertiary-color-bg-hover);
    }
  }

  &.alert {
    border: 1px solid var(--color-error);
    background: var(--color-error);
    svg {
      fill: var(--base-white);
    }
  }

  &.secondary {
    border: 1px solid var(--bg-gray-darkest);
    background: var(--button-color-secondary);

    &:focus,
    &:focus-visible {
      outline: none;
      box-shadow: 0 0 4px 4px rgba(66, 210, 243, 0.4);
    }
  }

  &:disabled,
  &.disabled {
    background: var(--button-color-bg-disabled);
    border: 1px solid var(--button-color-bg-disabled);
    color: var(--button-color-disabled);
  }
}
